import { dorisRequest, loginRequest } from '../config';
import { msalInstance } from '../index';

const getToken = async (api) => {
  const scope = api === 'doris' ? dorisRequest.scopes : loginRequest.scopes;
  const request = {
    account: msalInstance.getActiveAccount(),
    scopes: scope
  };

  const response = await msalInstance
    .acquireTokenSilent(request)
    .catch(async error => {
      console.log(error);
      return await msalInstance.acquireTokenRedirect(request);
    });

  return response.accessToken ? response.accessToken : null;
};

const getIdTokenClaims = async () => {
  const claims = await msalInstance.getActiveAccount();
  return claims;
};


export {
  getToken,
  getIdTokenClaims
};
